import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { CoreLink } from '@uncinc/react-drupal-core';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

import addressMapsLink from '../../helpers/addressMapsLink';
import type { WheelchairAccessible } from '../../types/uncinc_profile/taxonomy';

import './style.scss';

export interface LocationProps {
  name?: string;
  addressLine: string;
  postalCode: string;
  city: string;
  countryCode?: string;
  wheelchairAccessible?: WheelchairAccessible;
  renderAsLink?: boolean;
  className?: string;
}

const Address: React.FC<Pick<LocationProps, 'addressLine' | 'postalCode' | 'city'>> = (props) => {
  const { addressLine, postalCode, city } = props;

  return (
    <>
      <Icon name="location_on" />
      <span>{addressLine}, {postalCode} {city}</span>
    </>
  );
};

const Location: React.FC<LocationProps> = (props) => {
  const {
    name,
    addressLine,
    postalCode,
    city,
    countryCode = '',
    wheelchairAccessible,
    renderAsLink = true,
    className,
  } = props;

  const { t } = useTranslation('translation', { keyPrefix: 'taxonomy_term.location' });

  const classes = c('Location', className);

  const url = addressMapsLink({
    address_line1: addressLine,
    postal_code: postalCode,
    locality: city,
    country_code: countryCode,
  }, name);

  return (
    <ul className={classes}>
      <li>
        {renderAsLink ? (
          <CoreLink {...props} className="Location__item" href={url}>
            <Address addressLine={addressLine} postalCode={postalCode} city={city} />
          </CoreLink>
        ) : (
          <div className="Location__item">
            <Address addressLine={addressLine} postalCode={postalCode} city={city} />
          </div>
        )}
      </li>

      {wheelchairAccessible && (
        <li>
          <span className="Location__item">
            <Icon name="accessible" />
            <span>{t(`wheelchair_accessible.${wheelchairAccessible}`)}</span>
          </span>
        </li>
      )}
    </ul>
  );
};

export default Location;
